// Taken from https://stackoverflow.com/a/51255785
const Logger = {}
const noop = () => {
}

let debug = false
if ('URLSearchParams' in window) {
  const urlParams = new URLSearchParams(window.location.search)
  debug = urlParams.has('js-debug')
}

const logLevels = ['log', 'debug', 'info', 'warn', 'error']
logLevels.forEach((level) => {
  Logger[level] = debug ? window.console[level] : noop
})

export default Logger
